import { action } from 'easy-peasy';
import initStore from '../initStore';
import { IActionReset } from '../types';

const reset: IActionReset = action(state => {
  const { items, item, pagination } = initStore;

  state.items = items;
  state.item = item;
  state.pagination = pagination;
});

export default reset;
